import { createStore, createLogger } from "vuex";

const debug = process.env.NODE_ENV !== "production";

const modules = {};
const files = require.context("./Modules", true, /index\.js$/);

files.keys().forEach((path, i) => {
    let module = files(path);
    Object.keys(module).forEach((item) => {
        modules[item] = module[item];
    });
});

export default createStore({
    modules: modules,
    strict: debug,
    plugins: debug ? [createLogger()] : [],
});
